import Swal from "sweetalert2";
import {LoginReason} from "../social-login";

/**
 const params = {
     reason: "",
     redirectUrl: "",
     cardUuid: "",
     oauthProvider: "",
     oauthAccessToken: ""
 }
 **/
export const callBackLogin = async (navigate, login, params) => {
    const loginSuccessHandler = (representativeProfileLink) => {
        if (params.reason === LoginReason.CARD_REGISTER) {
            //TODO 프로필이 있으면 프로필 선택 페이지로 없으면 생성 페이지로
            navigate("/profile-link-generate", {
                state: {cardUuid: params.cardUuid}
            })
        } else if (params.reason === LoginReason.PROFILE_DRAFTED) {
            navigate(`/${params.profileLink}`)
        } else {
            navigate(`/${representativeProfileLink}`)
        }
    }

    const loginFailHandler = () => {
        if (params.reason === LoginReason.CARD_REGISTER) {
            navigate("/signup", {
                state: {
                    cardUuid: params.cardUuid,
                    oauthProvider: params.oauthProvider,
                    oauthAccessToken: params.oauthAccessToken
                }
            })
        } else {
            Swal.fire({
                title: '등록되지 않은 계정입니다.',
                text: '다시 로그인해 주세요.',
                customClass: 'swal-alert',
                allowOutsideClick: false,
                confirmButtonText: '확인',
                confirmButtonColor: '#2D2D2D'
            }).then(() => navigate("/login"))
        }
    }

    // TODO 현재는 대표 프로필이다.
    const [isLogin, representativeProfileLink] = await login(params.oauthProvider, params.oauthAccessToken)


    if (isLogin) {
        loginSuccessHandler(representativeProfileLink)
    } else {
        loginFailHandler()
    }
}